import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Backdrop from '@material-ui/core/Backdrop';
import Burger from '@material-ui/icons/Menu';
import Close from '@material-ui/icons/Close';
import PhoneIcon from '@material-ui/icons/Phone';
import GroupIcon from '@material-ui/icons/Group';
import MailOutline from '@material-ui/icons/MailOutline';
import { ReactComponent as Calendar } from './assets/calendar.svg';
import { ReactComponent as Tools } from './assets/tools.svg';
import { ReactComponent as Search } from './assets/search.svg';
import { useMedia } from 'use-media';
import Button from '../bouton/block';
import { SearchBar } from './SearchBar';
import { MobileMenu } from './MobileMenu';
import { SubMenu } from './SubMenu';
import clsx from 'clsx';
import style from './block.module.scss';

export default function Block({
    siteTitle,
    homeURL,
    logoURL,
    logoResponsiveURL,
    menu,
    menuRight = null,
    customSettings,
    showButtons = null,
    contactIcon = 'tel',
    searchSubTypes = 'page,post,custom_blog',
    theme = null,
    colorTempo = null,
}) {
    const isTablet = useMedia({ maxWidth: style.desktopBreakpoint });
    const isLaptop = useMedia({ maxWidth: style.laptopXLBreakpoint });
    const [menuOpened, setMenuOpened] = useState(false);
    const [searchOpened, setSearchOpened] = useState(false);
    const [tempoHeaderIsPresent, setTempoHeaderIsPresent] = useState(false);
    const urlLinkySpace = menuRight && customSettings.urlLinkySpace;

    const contactIcons = {
        tel: <PhoneIcon />,
        mail: <MailOutline />,
    };

    const toggleMenu = () => {
        setMenuOpened(!menuOpened);
        setSearchOpened(false);
    };

    useEffect(() => {
        if (
            theme === 'soregies' &&
            (colorTempo ||
                customSettings.telElectricityRepairs ||
                customSettings.telEmergency ||
                customSettings.telCustomerService)
        ) {
            setTempoHeaderIsPresent(true);
        }
    }, [
        theme,
        colorTempo,
        customSettings.telElectricityRepairs,
        customSettings.telEmergency,
        customSettings.telCustomerService,
    ]);

    useEffect(() => {
        if (menuOpened) {
            document.documentElement.style.overflow = 'hidden';
        } else {
            document.documentElement.style.overflow = 'initial';
        }
    }, [menuOpened]);

    return (
        <>
            <div className={clsx(style.header, style[theme], tempoHeaderIsPresent && style.tempoHeaderIsPresent)}>
                <div className={style.content}>
                    <a href={homeURL} className={style.logoCol}>
                        <img className={style.logo} src={logoURL} alt={siteTitle} width={200} height={38} />
                    </a>
                    {!isTablet && (
                        <div className={style.rightColMenu}>
                            {menu && (
                                <ul className={style.mainMenu}>
                                    {Object.values(menu).map((item) => {
                                        const hasChildren = Object.values(item.children).length > 0;
                                        return (
                                            <li
                                                key={item.ID}
                                                className={clsx(style.el, hasChildren && style.hasChildren)}
                                            >
                                                <a href={item.url}>{item.title}</a>
                                                {hasChildren && <SubMenu item={item} theme={theme} />}
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                            <div className={style.secondaryMenu}>
                                {showButtons && Object.values(showButtons).length > 0 && (
                                    <div className={style.wideScreenButtons}>
                                        {showButtons.toolbox && customSettings.urlTools && (
                                            <Button
                                                startIcon={<Tools />}
                                                link={customSettings.urlTools}
                                                linkType={'page'}
                                                type={'basicOutlined'}
                                                wrapper={false}
                                                className={style.pictoButton}
                                            />
                                        )}
                                        {showButtons.calendar && customSettings.urlEvents && (
                                            <Button
                                                startIcon={<Calendar />}
                                                link={customSettings.urlEvents}
                                                linkType={'page'}
                                                type={'basicOutlined'}
                                                wrapper={false}
                                                className={style.pictoButton}
                                            />
                                        )}
                                        {showButtons.search && (
                                            <Button
                                                startIcon={searchOpened ? <Close /> : <Search />}
                                                type={'basicOutlined'}
                                                className={clsx(style.pictoButton, style.searchButton)}
                                                onClick={() => setSearchOpened(!searchOpened)}
                                                wrapper={false}
                                            />
                                        )}

                                        {(customSettings.urlContactBtn || customSettings.telephone) && (
                                            <Button
                                                linkType={customSettings.urlContactBtn ? 'other' : 'tel'}
                                                link={
                                                    customSettings.urlContactBtn
                                                        ? customSettings.urlContactBtn
                                                        : customSettings.telephone
                                                }
                                                startIcon={contactIcons[contactIcon]}
                                                text={isLaptop ? null : customSettings.textContactBtn}
                                                type={'basicOutlined'}
                                                className={
                                                    (!customSettings.textContactBtn || isLaptop) && style.pictoButton
                                                }
                                                wrapper={false}
                                            />
                                        )}
                                        {customSettings.urlElectedSpaceBtn && (
                                            <Button
                                                text={customSettings.textElectedSpaceBtn}
                                                link={customSettings.urlElectedSpaceBtn}
                                                linkType={'page'}
                                                type={'primary'}
                                                wrapper={false}
                                            />
                                        )}
                                    </div>
                                )}
                                {menuRight && Object.values(menuRight).length > 0 && (
                                    <ul className={style.menuRight}>
                                        {Object.values(menuRight).map((m, index) => (
                                            <li
                                                key={index}
                                                className={clsx(
                                                    style.menuItem,
                                                    m.classes,
                                                    m.url === window.location.href && style.active,
                                                )}
                                            >
                                                <Button
                                                    className={style.button}
                                                    text={m.title}
                                                    link={m.url}
                                                    title={m.title}
                                                    type={m.classes.includes('primary') ? 'primary' : 'secondary'}
                                                    targetBlank={m.classes.includes('account')}
                                                    autoDemo
                                                />
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    )}
                    {isTablet && (
                        <div className={clsx(style.mobileActionButtons, !searchOpened && style.retracted)}>
                            {!showButtons && customSettings.telephone && (
                                <Button
                                    className={style.pictoButton}
                                    type={'primaryOutlined'}
                                    linkType={customSettings.urlContactBtn ? 'other' : 'tel'}
                                    link={
                                        customSettings.urlContactBtn
                                            ? customSettings.urlContactBtn
                                            : customSettings.telephone
                                    }
                                />
                            )}
                            {showButtons.search && (
                                <Button
                                    startIcon={searchOpened ? <Close /> : <Search />}
                                    type={'basicOutlined'}
                                    className={clsx(style.pictoButton, style.searchButton)}
                                    onClick={() => setSearchOpened(!searchOpened)}
                                    wrapper={false}
                                />
                            )}
                            {urlLinkySpace && (
                                <Button
                                    startIcon={<GroupIcon />}
                                    type={'basicOutlined'}
                                    className={style.pictoButton}
                                    link={urlLinkySpace}
                                    targetBlank={true}
                                />
                            )}
                            <Button
                                startIcon={<Burger />}
                                type={'primary'}
                                className={style.pictoButton}
                                onClick={toggleMenu}
                            />
                        </div>
                    )}
                </div>
            </div>
            <MobileMenu
                siteTitle={siteTitle}
                homeURL={homeURL}
                logoURL={logoURL}
                logoResponsiveURL={logoResponsiveURL}
                menu={menu}
                menuOpened={menuOpened}
                onClose={toggleMenu}
                customSettings={customSettings}
                showButtons={showButtons}
                colorTempo={colorTempo}
            />
            <Backdrop className={style.backdrop} open={menuOpened} onClick={toggleMenu} />
            {searchOpened &&
                ReactDOM.createPortal(
                    <SearchBar
                        searchOpened={searchOpened}
                        setSearchOpened={setSearchOpened}
                        searchSubTypes={searchSubTypes}
                        customSettings={customSettings}
                    />,
                    document.body,
                )}
        </>
    );
}
